module.exports = __webpack_public_path__ + "img/prize_get.b041513a.svg";